export const pages = {
	'hubScroll': { id: 'hubScroll', page: 'customScroll', getter: () => import(/* webpackChunkName: 'customScroll' */ 'components/bolt/customScroll/customScroll') },
	'termsScroll': { id: 'termsScroll', page: 'customScroll', getter: () => import(/* webpackChunkName: 'customScroll' */ 'components/bolt/customScroll/customScroll') },
	'aboutUsScroll': { id: 'aboutUsScroll', page: 'customScroll', getter: () => import(/* webpackChunkName: 'customScroll' */ 'components/bolt/customScroll/customScroll') },
	'contactScroll': { id: 'contactScroll', page: 'customScroll', getter: () => import(/* webpackChunkName: 'customScroll' */ 'components/bolt/customScroll/customScroll') }
};
import hub from 'components/bolt/hub/hub';
import text from 'components/bolt/text/text';
import gallery from 'components/bolt/gallery/gallery';
export const sections = [
	{ id: 'hub', isPreloaded: true, component: hub, parent: 'hubScroll' },
	{ id: 'footerNav', isPreloaded: true, component: text, parent: 'hubScroll' },
	{ id: 'aboutUsGallery', isPreloaded: true, component: gallery, parent: 'aboutUsScroll' },
	{ id: 'aboutUsText', isPreloaded: true, component: text, parent: 'aboutUsScroll' },
	{ id: 'aboutUsInProduction', isPreloaded: true, component: hub, parent: 'aboutUsScroll' },
	{ id: 'aboutUsFooterNav', isPreloaded: true, component: text, parent: 'aboutUsScroll' },
	{ id: 'contact', isPreloaded: true, component: text, parent: 'contactScroll' },
	{ id: 'contactFooterNav', isPreloaded: true, component: text, parent: 'contactScroll' },
	{ id: 'termsAndPrivacy', isPreloaded: true, component: text, parent: 'termsScroll' },
	{ id: 'termsFooterNav', isPreloaded: true, component: text, parent: 'termsScroll' }
];
